// Cardio helpers — cardio exercises use TIME (per round) instead of reps × weight.
export const isCardio = (ex) => {
  if (!ex) return false;
  const t = (ex.exercise_type || '').toLowerCase();
  const c = (ex.category || '').toLowerCase();
  return t === 'cardio' || c === 'cardio';
};

// seconds -> "m:ss" (empty string when no value)
export const secondsToMMSS = (sec) => {
  if (sec == null || sec === '' || isNaN(sec)) return '';
  const total = Math.max(0, Math.round(Number(sec)));
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${m}:${String(s).padStart(2, '0')}`;
};

// "m:ss" or plain seconds -> integer seconds (null when blank)
export const mmssToSeconds = (str) => {
  if (str == null || String(str).trim() === '') return null;
  const raw = String(str).trim();
  if (raw.includes(':')) {
    const [m, s] = raw.split(':');
    const mins = parseInt(m, 10) || 0;
    const secs = parseInt(s, 10) || 0;
    return mins * 60 + secs;
  }
  const n = parseFloat(raw);
  return isNaN(n) ? null : Math.round(n);
};

export const MOVEMENT_PATTERNS = [
  { id: 'squat', name: 'Squat' },
  { id: 'hinge', name: 'Hinge' },
  { id: 'horizontal_push', name: 'Horizontal Push' },
  { id: 'vertical_push', name: 'Vertical Push' },
  { id: 'horizontal_pull', name: 'Horizontal Pull' },
  { id: 'vertical_pull', name: 'Vertical Pull' },
  { id: 'carry', name: 'Carry' },
  { id: 'rotation', name: 'Rotation' },
  { id: 'anti_rotation', name: 'Anti-Rotation' },
  { id: 'isolation', name: 'Isolation' },
];
